<!-- eslint-disable import/no-cycle -->
<template>
  <section>
    <b-alert
      variant="primary"
      :show="showAlertFree()"
      dismissible
      @dismissed="showAlertFree = false"
    >
      <h4 class="alert-heading">
        Recurso não disponivel para o plano de teste
      </h4>
      <div class="alert-body">
        <span>A notificações estão disponiveis apartir do plano super.</span>
      </div>
    </b-alert>

    <h1>Notificações <feather-icon icon="BellIcon" /></h1>
    <h5>Escolha a loja no qual você quer enviar as notificações</h5>
    <b-table
      ref="refUserListTable"
      class="position-relative"
      :items="stores"
      responsive
      :fields="tableColumns"
      primary-key="id"
      show-empty
    >

      <!-- Column: Role -->
      <template #cell(notifications)="data">
        <div class="text-nowrap">
          <feather-icon
            :icon="resolveUserRoleIcon(data.item.notifications)"
            size="18"
            class="mr-50"
            :color="colorRoleIcon(data.item.notifications)"
          />
        </div>
      </template>

      <!-- Column: Status -->
      <template #cell(status)="data">
        <b-badge
          pill
          :variant="`light-${resolveUserStatusVariant(data.item.status)}`"
          class="text-capitalize"
        >
          {{ data.item.status }}
        </b-badge>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-b-tooltip.hover.bottom="'Clique aqui para conectar'"
          variant="primary"
          class="btn-icon"
          style="margin: 5px;"
          :to="{ name: 'stores-qrcode', params: { session: data.item.uuid } }"
        >
          <feather-icon icon="PowerIcon" />
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-b-tooltip.hover.bottom="'Configure suas notificações aqui'"
          style="margin: 5px;"
          variant="primary"
          class="btn-icon"
          :to="{ name: 'notifications-status', params: { uuid: data.item.uuid } }"
        >
          <feather-icon icon="MessageCircleIcon" />
        </b-button>

        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-b-tooltip.hover.bottom="'Configurar Alertas aqui'"
          v-b-modal.modal-prevent-closing
          style="margin: 5px;"
          variant="gradient-danger"
          class="btn-icon"
          @click="getPhone(data.item.uuid, data.item)"
        >
          <feather-icon icon="AlertCircleIcon" />
        </b-button>
        <!-----<router-link :to="{ name: 'stores-qrcode', params: { session: data.item.uuid } }"><feather-icon icon="PowerIcon"  v-b-tooltip.hover.bottom="'Clique aqui para conectar'"/></router-link>
        <router-link :to="{ name: 'notifications-status', params: { uuid: data.item.uuid } }" ><feather-icon icon="MessageCircleIcon" v-b-tooltip.hover.bottom="'Configure suas notificações aqui'" /></router-link>
        <a @click="getPhone(data.item.uuid, data.item)" v-b-modal.modal-prevent-closing ><feather-icon variant="warning" icon="AlertCircleIcon" v-b-tooltip.hover.bottom="'Configurar Alertas aqui'" /></a> ---->
      </template>
    </b-table>

    <!-- modal -->
    <b-modal
      id="modal-prevent-closing"
      ref="my-modal"
      title="Configure seu Alerta!"
      ok-title="Salvar"
      cancel-variant="outline-secondary"
      @ok="handleOk"
    >
      <h5>Insira um número de whatsapp para receber alertas caso as suas notificações sejam desconectadas.</h5>
      <form
        ref="form"
        @submit.stop.prevent="handleSubmit"
      >
        <b-form-group
          label="Whatsapp"
          label-for="name-input"
          invalid-feedback="É necessário inserir seu whatsapp!"
        >
          <b-form-input
            id="name-input"
            v-model="phone"
            required
          />
        </b-form-group>
      </form>
    </b-modal>
  </section>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BModal, BAlert, BInputGroup, BInputGroupPrepend, BForm, BFormGroup, VBTooltip,
} from 'bootstrap-vue'
import { getUserData } from '@/auth/utils'
import stores from '../../../functions/basics/stores'
import { getInstance } from './qrcode.js'
import { createAlert } from '../../../functions/basics/notifications'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BDropdown,
    BDropdownItem,
    BModal,
    BAlert,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BForm,
    VBTooltip,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      stores,
      tableColumns: [
        { key: 'name', label: 'Nome', sortable: true },
        { key: 'notifications', label: 'Status', sortable: true },
        { key: 'actions', label: 'Ações', sortable: true },
      ],
      resolveUserRoleIcon: role => {
        if (role === 1) return 'CheckCircleIcon'
        if (role === 0) return 'XCircleIcon'
      },
      colorRoleIcon: role => {
        if (role === 1) return 'green'
        if (role === 0) return 'grey'
      },
      phone: null,
      uuid: null,
    }
  },
  async mounted() {
    this.stores = await stores()
  },
  methods: {
    showAlertFree() {
      if (getUserData().role === 'admin' && getUserData().id >= 714 && getUserData().id <= 740) {
        return true
      }
      return false
    },
    async getPhone(uuid, phone) {
      const infoInstance = await getInstance(uuid)
      this.uuid = uuid
      this.phone = infoInstance.store.alertPhone
    },
    async handleOk() {
      await createAlert(this.uuid, this.phone).then(resp => {
        if (resp.status === 200) {
          this.$swal({
            title: 'Alerta Configurado!',
            text: 'A partir de agora suas configurações de alerta foram configurados.',
            icon: 'success',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          }).then(resp => { if (resp.isConfirmed === true) { window.location.reload() } })
        }
      }).catch(error => {
        this.$swal({
          title: 'Desculpe!',
          text: ' Não foi possivel configurar seu alerta. Por favor, tente mais tarde ou informe nosso suporte. Obrigado!',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
